import React from 'react';
import { InfoIcon } from "../../../ui";

export default function InfoIconExtendedLink(params: { label: string; href: string }) {

  return (
    <InfoIcon testId="infoIconInvoicesData">
      <a href={params.href} target='blank'>{params.label}</a>
    </InfoIcon>
  );
}